import { AgentHeaderMenuItem, SidebarConfig } from '@etninfinite/aiops';

// Keep the library menu empty and render actions in the host template to avoid inline-handler injection.
export const headerMenu: AgentHeaderMenuItem[] = [];

export const sidebarConfig: SidebarConfig = {
  overlay: false,
  position: 'right',
};
